
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/nft-boost",
      function () {
        return require("private-next-pages/products/nft-boost.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/nft-boost"])
      });
    }
  